import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "../../design-system/tokens";
interface Props { onFiles:(files:File[])=>void; label?:string; accept?:string; }
export function ReferenceDropzone({ onFiles, label, accept=".xlsx,.xls,.csv,.txt,.scd,.cid,.icd,.iid,.scl,.xml" }: Props) {
  const { t } = useTranslation("landing");
  const inputRef = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);
  return (
    <div onDragOver={(e)=>{e.preventDefault();setOver(true);}} onDragLeave={()=>setOver(false)}
      onDrop={(e)=>{e.preventDefault();setOver(false);onFiles([...e.dataTransfer.files]);}}
      onClick={()=>inputRef.current?.click()}
      className={cn("flex cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed p-8 text-center transition-colors",
        over ? "border-[var(--color-brand)] bg-[var(--color-brand-soft-10)]"
             : "border-[var(--color-border)] hover:border-[var(--color-brand-border-60)]")}>
      <input ref={inputRef} type="file" multiple accept={accept} className="hidden"
        onChange={(e)=>{ if(e.target.files) onFiles([...e.target.files]); }} />
      <p className="text-sm font-medium">{label ?? t("dropzone.default")}</p>
      <p className="text-xs text-[var(--color-on-surface-variant)]">{t("dropzone.localNote")}</p>
    </div>
  );
}
